import React, { useState, useEffect } from "react";
import { Card } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faTrash,
  faUpload,
  faCheckSquare,
  faSquare,
} from "@fortawesome/free-solid-svg-icons";

const Picture = ({
  data,
  isLoad,
  deletePictures,
  sendPicturesToGLA,
  folderId,
}) => {
  const [selected, setSelected] = useState([]);

  // Select all by default when data changes
  useEffect(() => {
    if (data.length) {
      setSelected(data.map((p) => p.id));
    } else {
      setSelected([]);
    }
  }, [data]);

  const allSelected = data.length > 0 && selected.length === data.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelected([]);
    } else {
      setSelected(data.map((p) => p.id));
    }
  };

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const downloadSelected = () => {
    data
      .filter((p) => selected.includes(p.id))
      .forEach((element) => {
        const a = document.createElement("a");
        a.href = element.base64;
        a.download = `${element.token}.${element.type.split("/")[1]}`;
        a.click();
      });
  };

  const handleDeleteSelected = () => {
    if (!selected.length) return;
    if (!window.confirm(`Supprimer ${selected.length} photo(s) ?`)) return;
    deletePictures(selected);
  };

  const handleSendToGLA = () => {
    const toSend = data.filter(
      (p) => selected.includes(p.id) && !p.sentToGLA
    );
    if (!toSend.length) {
      alert("Toutes les photos sélectionnées ont déjà été envoyées.");
      return;
    }
    if (
      !window.confirm(
        `Envoyer ${toSend.length} photo(s) vers GLA SOFTWARE ?`
      )
    )
      return;
    sendPicturesToGLA(
      folderId,
      toSend.map((p) => p.id)
    );
  };

  if (!data.length && !isLoad) return null;

  return (
    <Card title="Photos" className="h-100" isLoader={isLoad}>
      {data.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={toggleSelectAll}
          >
            <FontAwesomeIcon
              icon={allSelected ? faCheckSquare : faSquare}
              style={{ marginRight: "6px", color: allSelected ? "#2563eb" : "#9ca3af" }}
            />
            <span style={{ fontSize: "14px" }}>
              Tout sélectionner ({selected.length}/{data.length})
            </span>
          </div>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <button
              onClick={downloadSelected}
              disabled={!selected.length}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "6px 12px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                backgroundColor: "#fff",
                cursor: selected.length ? "pointer" : "not-allowed",
                opacity: selected.length ? 1 : 0.5,
                fontSize: "13px",
              }}
            >
              <FontAwesomeIcon icon={faDownload} />
              Télécharger
            </button>
            <button
              onClick={handleSendToGLA}
              disabled={!selected.length}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "6px 12px",
                border: "none",
                borderRadius: "6px",
                backgroundColor: selected.length ? "#2563eb" : "#93c5fd",
                color: "#fff",
                cursor: selected.length ? "pointer" : "not-allowed",
                fontSize: "13px",
              }}
            >
              <FontAwesomeIcon icon={faUpload} />
              Envoyer vers GLA
            </button>
            <button
              onClick={handleDeleteSelected}
              disabled={!selected.length}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "6px 12px",
                border: "none",
                borderRadius: "6px",
                backgroundColor: selected.length ? "#dc2626" : "#fca5a5",
                color: "#fff",
                cursor: selected.length ? "pointer" : "not-allowed",
                fontSize: "13px",
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
              Supprimer
            </button>
          </div>
        </div>
      )}
      <Row>
        {data.map((element, key) => (
          <Col key={element.id} xs={12} md={3} lg={2} className="mb-10">
            <div
              style={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "10px",
                border: selected.includes(element.id)
                  ? "2px solid #2563eb"
                  : "2px solid transparent",
              }}
            >
              {/* Checkbox */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  padding: "8px",
                  cursor: "pointer",
                  zIndex: 2,
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                  borderEndEndRadius: "10px",
                }}
                onClick={() => toggleSelect(element.id)}
              >
                <FontAwesomeIcon
                  icon={
                    selected.includes(element.id) ? faCheckSquare : faSquare
                  }
                  style={{
                    fontSize: "18px",
                    color: selected.includes(element.id)
                      ? "#2563eb"
                      : "#9ca3af",
                  }}
                />
              </div>
              {/* Sent badge */}
              {element.sentToGLA ? (
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "rgba(22, 163, 74, 0.8)",
                    color: "#fff",
                    fontSize: "11px",
                    textAlign: "center",
                    padding: "2px 0",
                    zIndex: 2,
                  }}
                >
                  Envoyée GLA
                </div>
              ) : null}
              <img
                style={{ maxWidth: "100%", display: "block" }}
                src={element.base64}
                alt={`car-${key}`}
              />
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default Picture;
